import axios from "axios";
//https://discord.com/api/webhooks/952934992474943489/HWvpkWpgEmH0RNLHPqWM1B9nuLFt1YsMWs8iCr-Jl_5FHKFzH8g_kSywdMlCaaAJiH62
const HOOK_GENERAL = 'https://ptb.discord.com/api/webhooks/953675903173525504/WqlGuu7dJ_VgXBiXgBmMSZB7tvNPQA75czSHOmpiARuXNmJooasUYfh-QB1LZo-Dehf2';
//other hooks to other text channels can be linked here

//perhaps also the bot constants here like the image and view/name of the bot

const newValorantUserMessage = async (profilename,profiletag) => {
    const userid = profilename+"#"+profiletag;
    const embed = {
        "content": null,
        "embeds": [
            {
            "title": "New Valo Gangsta ready to JAAAAAMMMM!!!",
            "color": 65290,
            "fields": [
                {
                "name": "Valorant ID",
                "value": userid
                }
            ]
            }
        ]
    };
    axios.post(HOOK_GENERAL, embed).then(
        response => console.log(response.data.id)
    );
};

const TestModeratorMessage = async (userid) => {
    const embed = {
        "content": null,
        "embeds": [
          {
            "title": "Mod sending message test",
            "color": 65290,
            "fields": [
              {
                "name": "Current mod sending message",
                "value": userid
              }
            ]
          }
        ]
      };

    axios.post(HOOK_GENERAL, embed).then(
        response => console.log(response.data)
    );
};

const NewTeamCompMessage = async (teamcomp,team) => {
    const title = `New comp for the ${team} team `;
    if(team == "red"){var color=16712965}else{var color = 10749}
    var fieldsteam = [];
    for (let i = 0; i < teamcomp.length; i++) {
        console.log(teamcomp[i]);
        var toaddfieldsteam = {}
        if(teamcomp[i].anchored == true){
            toaddfieldsteam["name"]  = `Ambassador / Player ${i+1}`;
        }else{
            toaddfieldsteam["name"]  = `Player ${i+1}`;
        }
        
        toaddfieldsteam["value"] = teamcomp[i].name
        fieldsteam.push(toaddfieldsteam);
    }
    const embed = {
        "content": null,
        "embeds": [
          {
            "title": title,
            "color": color,
            "fields": fieldsteam
          }
        ]
      };

    axios.post(HOOK_GENERAL, embed).then(
        response => console.log(response.data)
    );
};



export {
    newValorantUserMessage,
    TestModeratorMessage,
    NewTeamCompMessage
};